module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_cat02-97d8873befc112ee2659c6ef14dad147.svg";